import Swal from 'sweetalert2';
import { store } from '../store';
import { setUserData } from '../store/setting/actions';
import { clearStoredTeacherModulePermissionData } from './teacherModulePermissions';

export const AUTH_TOKEN_KEY = 'nemontoAuthToken';
export const AUTH_EMAIL_KEY = 'user_email';

// API paths that are called before a session exists (login/signup/otp/forgot
// password flows). A 401 from these means "wrong credentials", not "your
// session expired" - they must never trigger the auto-logout flow below.
export const UNAUTHENTICATED_API_PATHS = [
  'users/v1/auth/login',
  'users/v1/auth/match-login-otp',
  'users/v1/auth/resend-otp',
  'users/v1/auth/verify-email',
  'users/v1/auth/match-email-otp',
  'users/v1/auth/register',
  'users/v1/auth/forgot-password',
  'users/v1/auth/forgot-password-save',
  'users/v1/auth/login-with-email',
  'users/v1/auth/match-otp-email',
  'users/v1/auth/resend-login-otp',
  'users/v1/auth/adminpass',
];

function clearAuthSession() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_EMAIL_KEY);
  clearStoredTeacherModulePermissionData();
  store.dispatch(setUserData(JSON.stringify('')));
}

// Manual, user-initiated sign out (e.g. clicking "Sign out" in the header).
export function logout(navigate) {
  clearAuthSession();
  if (navigate) {
    navigate('/');
  } else {
    window.location.href = '/';
  }
}

let sessionExpiredHandled = false;

// Called from the axios response interceptor when a request that carried an
// auth token comes back 401 - i.e. the server has rejected the stored token
// as expired/invalid. Guarded against firing more than once since several
// in-flight requests can all 401 at the same time after expiry.
export function handleSessionExpired() {
  if (sessionExpiredHandled) {
    return;
  }
  sessionExpiredHandled = true;

  clearAuthSession();

  Swal.fire({
    icon: 'info',
    title: 'Session expired',
    text: 'Your session has expired. Please sign in again.',
    confirmButtonText: 'OK',
    timer: 4000,
    timerProgressBar: true,
  }).finally(() => {
    window.location.href = '/auth/sign-in';
  });
}
